var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.message)+" You need at least "+_vm._s(_vm.gasRequired)+" "+_vm._s(_vm.networkName)+" ETH to your wallet to send this transaction. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }